<template>
  <div class="DataTable">
    <v-layout row wrap>
        <v-flex xs9></v-flex>
        <v-flex xs3>
          <v-text-field v-model="search" append-icon="search" label="Pretraga" xs5 hide-details
                  style="margin-top: 0px !important"></v-text-field>
        </v-flex>
      </v-layout>
    <v-layout column>
      <v-flex style="overflow: auto">
        <v-data-table
          :headers="headers"
          :items="items"
          :search="search"
          hide-actions
          class="elevation-1"
          :pagination.sync="pagination"
        >
          <template slot="headers" slot-scope="props">
            <tr>
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '', header.align === 'left' ? 'text-xs-left' : 'text-xs-center']"
                @click="changeSort(header.value)"
              >
                <v-icon small v-if="header.sortable !== false"
                      >arrow_upward</v-icon
                    >
                {{ header.text }}
              </th>
            </tr>
          </template>

          <template slot="items" slot-scope="props">
            <tr>
              <td style="text-align:center;">{{ props.index + 1 }}</td>
              <td style="display:none;">{{ props.item.id }}</td>
              <td style="text-align:center; padding:5px;">{{ props.item.name }}</td>
              <td style="text-align:center; padding:0px;">{{ props.item.tankType.name }}</td>
              <td style="text-align:center; padding:0px;">{{ props.item.inventoryNumber }}</td>
              <td style="text-align:center; padding:5px;">{{ formatDate1(props.item.bayingDate) }}</td>
              <!-- <td style="text-align:center;">{{ props.item.capacity }}</td> -->
              
              <td v-if='props.item.unitOfMeasure !== null && props.item.piece > 0' style="text-align:center;">{{ props.item.capacity + ' ' + props.item.unitOfMeasure.mark + ' (' + props.item.piece + ')' }}</td>
              <td class="justify-center align-content-center pa-2 text-xs-center" v-else-if='props.item.unitOfMeasure !== null'
              >{{ props.item.capacity + ' ' + props.item.unitOfMeasure.mark }}</td>
              <td class="justify-center align-content-center pa-2 text-xs-center" v-else-if='props.item.piece > 0'
              >{{ props.item.capacity + ' (' + props.item.piece + ')' }}</td>
              <td class="justify-center align-content-center pa-2 text-xs-center" v-else
              >{{ props.item.capacity }}</td>
              <td style="text-align:center; padding:0px;" v-if="props.item.position !== null">{{ props.item.position }}</td>
              <td style="text-align:center; padding:0px;" v-else>-</td>

              <td class="DataTable__ButtonHolder">
                <img
                  class="DataTable__Button"
                  title="Izmena"
                  src="../assets/icons/zatabele/ico-edit2.svg"
                  alt="ulaz-grozdja"
                  @click="editItem(props.item)"
                >
                <img
                  v-if='props.item.tankType.id === 15'
                  class="DataTable__Button"
                  title="Dodavanje barika"
                  src="../assets/icons/zatabele/ico-add.svg"
                  alt="delete-item"
                  @click="otvoriDialog(props.item)"
                >
                <img
                  v-if='props.item.tankType.id === 14'
                  class="DataTable__Button"
                  title="Pregled korišćenja barika"
                  src="../assets/icons/zatabele/ico-options.svg"
                  alt="delete-item"
                  @click="otvoriDialogBarici(props.item)"
                >
                <img
                  class="DataTable__Button"
                  title="Brisanje"
                  src="../assets/icons/zatabele/ico-delete2.svg"
                  alt="delete-item"
                  @click="deleteItem(props.item)"
                >
              </td>
            </tr>
          </template>
          <template slot="no-data">
            <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
            <v-alert slot="no-results" :value="true" color="primary" icon="info">Nema podataka.</v-alert>
          </template>
          <!-- <v-alert slot="no-results" :value="true" color="error" icon="warning">
        Trazili ste "{{ search }}" ali nema rezultata.
          </v-alert>-->
        </v-data-table>
      </v-flex>
    </v-layout>
    <TokenComponent ref="frmtoken"/>

    <v-dialog v-model="dialogNoteStanjeBarika" scrollable content-class="ModalInModal">
      <v-container style="padding:10px;">
        <div class="DataTable">
          <v-form ref="form_modal" lazy-validation>
            <v-layout>
              <v-flex xs11 pa-2 style="font-size: 20px !important">
                {{ this.naslovKoriscenjeBarika }}
              </v-flex>
              <v-flex xs1 pa-2>
                <a
                  class="closeModalInModalBtn"
                  @click.prevent="closeModalInModalStanjeBarika"
                 
                >
                  <v-icon>close</v-icon>
                </a>
              </v-flex>
            </v-layout>

            <v-layout column>
              <v-flex style="overflow: auto">
                <v-data-table
                  :headers="headers_modal_stanje_barika"
                  :items="items_modal_stanje_barika"
                  hide-actions
                  class="elevation-1"
                  :pagination.sync="pagination"
                >
                  <template slot="headers" slot-scope="props_modal">
                    <tr>
                      <th
                        v-for="header in props_modal.headers"
                        :key="header.text"
                        :class="[
                          'column sortable',
                          pagination.descending ? 'desc' : 'asc',
                          header.value === pagination.sortBy ? 'active' : '',
                        ]"
                        @click="changeSort(header.value)"
                      >
                        <v-icon>arrow_upward</v-icon>
                        {{ header.text }}
                      </th>
                    </tr>
                  </template>
                  <template slot="items" slot-scope="props_modal">
                    <tr>
                      <td style="text-align: center; padding: 5px">
                        {{
                          props_modal.item.wine 
                        }}
                      </td>
                      <td style="text-align: center; padding: 5px">
                        {{ props_modal.item.phase }}
                      </td>
                      
                      <td style="text-align: center; padding: 5px">
                        {{ props_modal.item.batchName }}
                      </td>
                      <td style="text-align: center; padding: 0px">
                        {{ formatDateTime(props_modal.item.from) }}
                      </td>
                      <td style="text-align: center; padding: 0px">
                        {{ formatDateTime(props_modal.item.to) }}
                      </td>
                      
                      <td style="text-align: center; padding: 5px" v-if="props_modal.item.years > 0">
                        {{
                          '    ' + props_modal.item.years + ' g    ' + props_modal.item.months + ' m'
                        }}
                      </td>
                      <td style="text-align: center; padding: 5px" v-else>
                        {{
                          '    ' + props_modal.item.months + ' m'
                        }}
                      </td>
                    </tr>
                  </template>
                  <template slot="no-data">
                    <v-alert
                      slot="no-results"
                      :value="true"
                      color="primary"
                      icon="info"
                      >Nema podataka.</v-alert
                    >
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-form>
        </div>
      </v-container>
    </v-dialog>
  </div>
</template>


<script>
import { serverBus } from "../main";
import { readJSON, scrollToTopBasNaVrh } from "../helpers/Functions";
import TokenComponent from "../components/Token";

export default {
  name: "TankTable",
  props: {
    msg: String
  },
  components: {
      TokenComponent
    },
  data: () => ({
    pagination: {
      sortBy: "name",
      rowsPerPage: 10000000
    },
    search: "",
    headers: [
      // {
      // 	text: "ID",
      // 	align: "left",
      // 	sortable: true,
      // 	value: "id"
      // },
      { text: "", value: "", sortable: false },
      { text: "Naziv", value: "name" },
      { text: "Tip", value: "tankType.name" },
      { text: "Inventarni broj", value: "inventoryNumber" },
      { text: "Datum nabavke", value: "bayingDate" },
      { text: "Kapacitet", value: "capacity" },
      // { text: "Jed. mere", value: "unitOfMeasure.name" },
      // {text: "Kupovina", value: "bayingDate"},
      {text: "Redosled na prikazu", value: "position"},
      { text: "Funkcije", value: "funkcije", sortable: false }
    ],
    items: [],
    editedIndex: -1,
    editedItem: {
      id: 0,
      name: "",
      description: ""
    },
    defaultItem: {
      id: 0,
      name: "",
      description: ""
    },
    idRoom: 0,
    items_modal_stanje_barika: [],
    dialogNoteStanjeBarika: false,
headers_modal_stanje_barika: [
      { text: "Vino", value: "wine" },
      { text: "Faza", value: "phase" },
      { text: "Šarža", value: "batchName" },
      { text: "Od", value: "from" },
      { text: "Do", value: "to" },
      { text: "Odležavalo", value: "wineType" }
    ],
    naslovKoriscenjeBarika: "Pregled koriscenja barika"
  }),
  methods: {
    formatDateTime(date) {
      
      
      let answer = "";

      if(date !== null && typeof date !== "undefined"){
        let lokDate = date.split('T')[0];
        let lokTime = date.split('T')[1];

        let month = lokDate.split('-')[1];
        let day = lokDate.split('-')[2];
        const year = lokDate.split('-')[0];

        let HH = lokTime.split(':')[0];
        let mm = lokTime.split(':')[1];

        answer = [day, month, year].join("."); // + ' ' + [HH, mm].join(":");
      }

      return answer
    },
    save(e) {
      console.log(e);
    },
    cancel() {},
    open(e) {
      console.log(e);

      

      const index = this.selected_izabrani_tankovi.indexOf(e);
      if (index > -1) {
        this.selected_izabrani_tankovi.splice(index, 1);
      }
    },
    close() {},
    closeModalInModalStanjeBarika() {
      this.items_modal_stanje_barika = [];

      this.dialogNoteStanjeBarika = false;

    },
otvoriDialogBarici(item) {
      //scrollToTop(300);

      this.items_modal_stanje_barika = [];

      this.dialogNoteStanjeBarika = true;
      this.getAllSifarnikStanjeBarika(item.id);
      
      this.naslovKoriscenjeBarika = "Pregled koriscenja barika " + item.name;
    },
    getAllSifarnikStanjeBarika(tankId) {
      this.$http
        .get(
          this.globalServiceLocation + this.globalPort + "/tank/barique_history/" + tankId,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {

          console.log(response.data);

          this.items_modal_stanje_barika = response.data;

        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/tank/barique_history/" + tankId,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.items_modal_stanje_barika = response.data;

                    })
                    .catch((e) => {

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    formatDate1 (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    },
    otvoriDialog(item) {
      //scrollToTop(300);

      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);

      serverBus.$emit("otvori_modal", item);
    },
    deleteSifarnik(id) {
      this.$http
        .delete(this.globalServiceLocation + this.globalPort + "/tank/delete/" + id, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              })
        .then(response => {
          // // // console.log(response);

          this.getAllSifarnik();
        })
        .catch(e => {
          // // console.log(e.response);

          if (!e.response) {
              alert(this.$t("error.message"));
            } else {
                if (e.response.status === 401) {

            this.$refs.frmtoken.osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
              .then(result => {
                // // console.log(result);
                // // console.log("Novi token - " + localStorage.getItem("user-token"));

                this.$http
        .delete(this.globalServiceLocation + this.globalPort + "/tank/delete/" + id, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              })
        .then(response => {
          // // // console.log(response);

          this.getAllSifarnik();
        })
        .catch(e => {
          // // console.log(e.response);

          let pomError = readJSON(e.response.data.message);
          alert(pomError);
        });
              });
          } else {
            let pomError = readJSON(e.response.data.message);
            alert(pomError);
          }
            }
        });
    },
    getAllSifarnik() {
      this.$http
        .get(
          // this.globalServiceLocation + this.globalPort + "/tank/all",
          this.globalServiceLocation + this.globalPort + "/tank/room/" + this.idRoom, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              }
        )
        .then(response => {
          this.items = response.data;

          // var i;
          // for (i = 0; i < response.data.length; i++) {
          // 	this.items.push(response.data[i].tank);
          // }

          //// // console.log(this.items);
        })
        .catch(e => {
          // // console.log(e.response);

          if (!e.response) {
              alert(this.$t("error.message"));
            } else {
                if (e.response.status === 401) {

            this.$refs.frmtoken.osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
              .then(result => {
                // // console.log(result);
                // // console.log("Novi token - " + localStorage.getItem("user-token"));

                this.$http
        .get(
          // this.globalServiceLocation + this.globalPort + "/tank/all",
          this.globalServiceLocation + this.globalPort + "/tank/room/" + this.idRoom, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              }
        )
        .then(response => {
          this.items = response.data;

          // var i;
          // for (i = 0; i < response.data.length; i++) {
          // 	this.items.push(response.data[i].tank);
          // }

          //// // console.log(this.items);
        })
        .catch(e => {
          // // console.log(e.response);

          let pomError = readJSON(e.response.data.message);
          alert(pomError);
        });
              });
          } else {
            let pomError = readJSON(e.response.data.message);
            alert(pomError);
          }
            }
        });
    },
    getAllSifarnik_Pom(idTank) {
      this.$http
        .get(
          // this.globalServiceLocation + this.globalPort + "/tank/all",
          this.globalServiceLocation + this.globalPort + "/tank/room/" + this.idRoom, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              }
        )
        .then(response => {
          this.items = response.data;

          const item = this.items.find(x => x.id === idTank);
          serverBus.$emit("applied_tank", item);
        })
        .catch(e => {
          // // console.log(e.response);

          if (!e.response) {
              alert(this.$t("error.message"));
            } else {
                if (e.response.status === 401) {

            this.$refs.frmtoken.osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
              .then(result => {
                // // console.log(result);
                // // console.log("Novi token - " + localStorage.getItem("user-token"));

                this.$http
        .get(
          // this.globalServiceLocation + this.globalPort + "/tank/all",
          this.globalServiceLocation + this.globalPort + "/tank/room/" + this.idRoom, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              }
        )
        .then(response => {
          this.items = response.data;

          const item = this.items.find(x => x.id === idTank);
          serverBus.$emit("applied_tank", item);
        })
        .catch(e => {
          // // console.log(e.response);

          let pomError = readJSON(e.response.data.message);
          alert(pomError);
        });
              });
          } else {
            let pomError = readJSON(e.response.data.message);
            alert(pomError);
          }
            }
        });
    },
    editItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);

      setTimeout(() => {
        serverBus.$emit("scroll_to_top");

        // console.log(document.getElementsByClassName("DataTableMaka"))
        //   document.getElementsByClassName("DataTableMaka")[0].scrollIntoView(true);



        }, 300);


      serverBus.$emit("applied_tank", item);
    },

    deleteItem(item) {
      const index = this.items.indexOf(item.tank);

      //// // console.log(item.quantity);

      if (item.quantity < 0 || item.quantity == null) {
        confirm("Da li ste sigurni da želite obrisati izabrani zapis?") &&
          this.deleteSifarnik(item.id);
      } else {
        alert("Nije moguće obrisati tank u kome ima vina");
      }
    },
    changeSort(column) {
      if (column !== "funkcije")
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending;
        } else {
          this.pagination.sortBy = column;
          this.pagination.descending = false;
        }
    }
  },
  mounted() {
    //	alert('mounted tabela');

    this.getAllSifarnik();

    serverBus.$on("refresh_tank", idRoom => {
      // alert(idRoom);
      this.idRoom = idRoom;

      this.getAllSifarnik();

    }),
    serverBus.$on("refresh_tank_pom", (idRoom, idTank) => {
      // alert(idRoom);
      this.idRoom = idRoom;

      this.getAllSifarnik_Pom(idTank);
    }),
      serverBus.$on("tank", idRoom => {
        // alert('makarije');
        // alert(idRoom);

        this.idRoom = idRoom;

        this.getAllSifarnik();
      });
  }//,
  // watch: {
  //   "$route.params.id"(newId, oldId) {
  //     				alert('watch');
  //     // alert(newId);

  //     this.idRoom = newId;

  //     this.getAllSifarnik();
  //   }
  // }
};
</script>

<style lang="scss" scoped>

.closeModalInModalBtn {
  position: absolute;
  right: 0;
  top: 0;
}

.v-toolbar{
  &__content {
    margin-top: 0px;
}
}
</style>